export class FactoryConfigurationModel {
   public cluster: string;
   public factory: string;
   public lineName: string;
   public category: string;
   public subCategory: string;
   public createdBy: string;
   public lineId: string;
}
